export class ProductCenterFragments {
  /*
   * GraphQL Fragment for the Performance Table Exhibit
   */
  public static performanceTableFragment = `
    productCenterExhibit {
      products {
        productCode
        parentProductCode
        productName {
          apir
          shareClass
          baseCurrencyName
          fundLink
          fundName
          vehicleTypeName
          isin
          investmentStrategiesAssetClassName
          investmentStrategiesRegionName
          sfdrClassification
          declarationFrequencyName
        }
        disclaimers {
          disclaimerText {
            html
          }
          positioning
        }
        performance {
          performanceAsOfDate
          morningstarMedalistRating
          fundReturns {
            yearToDate {
              feeType
              value
            }
            oneYear {
              feeType
              value
            }
            threeYears {
              feeType
              value
            }
            fiveYears {
              feeType
              value
            }
            tenYears {
              feeType
              value
            }
            sinceInception {
              feeType
              value
            }
          }
          inceptionDate
        }
        pricing {
          performanceReportURL
          quarterlyReportURL
          applicationPrice
          withdrawalPrice
          navPrice
          priceAsOfDate
        }
        cumulativeChart {
          benchmarks {
            name
          }
          data {
            sinceInception {
              asOfDate
              fundValue
              benchmarkValues
            }
            oneYear {
              asOfDate
              fundValue
              benchmarkValues
            }
            threeYears {
              asOfDate
              fundValue
              benchmarkValues
            }
            fiveYears {
              asOfDate
              fundValue
              benchmarkValues
            }
            tenYears {
              asOfDate
              fundValue
              benchmarkValues
            }
          }
        }
        esg {
          proxyVotingSummary
          carbonFootprintSummary
          esgEngagementReport
          esgImpactAnnualReport
        }
        documents {
          fundProfile
          productDisclosureStatement
          targetMarketDetermination
        }
      }
      disclaimers {
        disclaimerText {
          html
        }
        positioning
      }
    }
`;
  public static readonly productCenterFragment = `
        ${ProductCenterFragments.performanceTableFragment}
      `;
}
